// Lazy load mobile product card sliders
if ('IntersectionObserver' in window) {
  const lazySliderObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && window.innerWidth <= 767) {
        const sliderContainer = entry.target;
        const productHandle = sliderContainer.dataset.productHandle;
        
        if (productHandle && !sliderContainer.dataset.loaded) {
          sliderContainer.dataset.loaded = 'true';
          
          // Fetch the slider HTML from a dedicated section
          fetch(`${window.Shopify.routes.root}products/${productHandle}?section_id=card-slider`)
            .then(response => response.text())
            .then(html => {
              // Extract the slider content from the response
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const sliderContent = doc.querySelector('.product-card-slider-content');
              
              if (sliderContent) {
                sliderContainer.innerHTML = sliderContent.innerHTML;
              } else {
                console.warn('Slider content not found for:', productHandle);
              }
            })
            .catch(error => {
              console.error('Error loading slider:', error);
            });
        }
        
        observer.unobserve(sliderContainer);
      }
    });
  }, {
    rootMargin: '100px', // Start loading 100px before entering viewport
    threshold: 0.01
  });

  // Observe all lazy sliders on page load
  const observeSliders = () => {
    document.querySelectorAll('[data-lazy-slider]:not([data-loaded])').forEach(slider => {
      lazySliderObserver.observe(slider);
    });
  };

  // Initial observation
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSliders);
  } else {
    observeSliders();
  }
  
  // Re-observe on AJAX product grid updates
  document.addEventListener('ajax:collection-updated', observeSliders);
}
